import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreviousRouteService {
  private previousUrl$ = new BehaviorSubject<string>('');
  public currentUrl$ = new BehaviorSubject<string>('');

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.previousUrl$.next(this.currentUrl$.value);
        this.currentUrl$.next(event.urlAfterRedirects);
      });
  }

  getPreviousUrl() {
    return this.previousUrl$.asObservable();
  }
}
